
const rawVulnSelectors = {
  getAllRawVulns: (state) => state.rawVulns.vulns,
  getRawVulnsCount: (state) => state.rawVulns.totalCount,
  getLoading: (state) => state.rawVulns.status.loading,
};

export default rawVulnSelectors;
